import { Controller } from 'stimulus'

// Drives the booking screen's inline timezone field: pre-selects the browser's
// detected zone when none is saved, and submits the field (saving the zone +
// reloading the slots) when the parent picks one. When the parent has no saved
// zone yet, a successful pre-fill auto-submits so the detected zone confirms in
// one step instead of blocking the page.
export default class extends Controller {
  static targets = ['timezoneForm', 'timezoneSelect']
  static values = { needsTimezone: Boolean }

  declare readonly timezoneFormTarget: HTMLFormElement
  declare readonly timezoneSelectTarget: HTMLSelectElement
  declare readonly hasTimezoneFormTarget: boolean
  declare readonly hasTimezoneSelectTarget: boolean
  declare readonly needsTimezoneValue: boolean

  connect() {
    const prefilled = this.prefillBrowserZone()
    if (this.needsTimezoneValue && prefilled) {
      this.submitTimezone()
    }
  }

  // Save the chosen zone and reload the slot list in it.
  timezoneChanged() {
    this.submitTimezone()
  }

  private submitTimezone() {
    if (this.hasTimezoneFormTarget) {
      this.timezoneFormTarget.requestSubmit()
    }
  }

  // Returns true when it set the select to the browser's detected zone (only
  // possible when nothing is selected yet and the zone is a valid option).
  private prefillBrowserZone(): boolean {
    if (!this.hasTimezoneSelectTarget || this.timezoneSelectTarget.value)
      return false

    const browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const hasOption = Array.from(this.timezoneSelectTarget.options).some(
      (option) => option.value === browserZone,
    )
    if (hasOption) {
      this.timezoneSelectTarget.value = browserZone
      return true
    }
    return false
  }
}
